module.exports = __webpack_public_path__ + "img/icon1.54cbd0d7.svg";